import { createDataSelectors } from "@app/modules/app.reducers";
import { Log } from "@ea/shared_types/types";

export const logsDataSelectors = createDataSelectors<Log>()("logs");
